module.exports = {
    xs: "480px",
    sm: "640px",
    md: "768px",
    lg: "1025px",
    xl: "1280px",
    // "2xl": "1536px" // Remove largest breakpoint
};
